export default __webpack_public_path__ + "static/media/ravenous.491ecba5.PNG";